module.exports = __webpack_public_path__ + "static/media/11_Artistic video wall - New York City.0253885d.jpg";